module.exports = __webpack_public_path__ + "img/materials.5467667e.png";